import { isNodeActive } from '@ametista-ai/editor/utils';
import { useEditorState } from '@handlewithcare/react-prosemirror';
import { Button, Group, Menu } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Icon } from '@/ui';
import { useToggleEditorNode } from './useToggleEditorNode';

export function TextBlockMenu() {
  const state = useEditorState();
  const [opened, { toggle, close }] = useDisclosure(false);

  const toggleH1 = useToggleEditorNode('heading', { level: 1 });
  const isH1Active = isNodeActive(state.schema.nodes['heading'], { level: 1 }, state);

  const toggleH2 = useToggleEditorNode('heading', { level: 2 });
  const isH2Active = isNodeActive(state.schema.nodes['heading'], { level: 2 }, state);

  const toggleH3 = useToggleEditorNode('heading', { level: 3 });
  const isH3Active = isNodeActive(state.schema.nodes['heading'], { level: 3 }, state);

  const toggleH4 = useToggleEditorNode('heading', { level: 4 });
  const isH4Active = isNodeActive(state.schema.nodes['heading'], { level: 4 }, state);

  const toggleH5 = useToggleEditorNode('heading', { level: 5 });
  const isH5Active = isNodeActive(state.schema.nodes['heading'], { level: 5 }, state);

  const toggleH6 = useToggleEditorNode('heading', { level: 6 });
  const isH6Active = isNodeActive(state.schema.nodes['heading'], { level: 6 }, state);

  const toggleParagraph = useToggleEditorNode('paragraph');
  const isParagraphActive = isNodeActive(state.schema.nodes['paragraph'], {}, state);

  return (
    <Menu opened={opened} onClose={close}>
      <Menu.Target>
        <Button size="xs" variant="default" onClick={toggle}>
          <Group gap="xs">
            {isParagraphActive && <Icon name="letterCase" />}
            {isH1Active && <Icon name="h1" />}
            {isH2Active && <Icon name="h2" />}
            {isH3Active && <Icon name="h3" />}
            {isH4Active && <Icon name="h4" />}
            {isH5Active && <Icon name="h5" />}
            {isH6Active && <Icon name="h6" />}
            {opened ? <Icon name="chevronUp" /> : <Icon name="chevronDown" />}
          </Group>
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          onClick={toggleParagraph}
          rightSection={isParagraphActive && <Icon name="check" />}
        >
          <Icon name="letterCase" />
        </Menu.Item>
        <Menu.Item onClick={toggleH1} rightSection={isH1Active && <Icon name="check" />}>
          <Icon name="h1" />
        </Menu.Item>
        <Menu.Item onClick={toggleH2} rightSection={isH2Active && <Icon name="check" />}>
          <Icon name="h2" />
        </Menu.Item>
        <Menu.Item onClick={toggleH3} rightSection={isH3Active && <Icon name="check" />}>
          <Icon name="h3" />
        </Menu.Item>
        <Menu.Item onClick={toggleH4} rightSection={isH4Active && <Icon name="check" />}>
          <Icon name="h4" />
        </Menu.Item>
        <Menu.Item onClick={toggleH5} rightSection={isH5Active && <Icon name="check" />}>
          <Icon name="h5" />
        </Menu.Item>
        <Menu.Item onClick={toggleH6} rightSection={isH6Active && <Icon name="check" />}>
          <Icon name="h6" />
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
